<button
  type="button"
  [disabled]="disabled()"
  (click)="buttonClick.emit()"
  class="relative w-4 h-20 rounded-l-xl backdrop-blur-[2px] flex items-center justify-center cursor-pointer disabled:cursor-not-allowed disabled:opacity-50 active:opacity-80 transition-opacity duration-150"
  [style.background-color]="'var(--bot-widget, #A62A29)'"
>
  <bevvi-icon
    [icon]="expanded() ? iconsEnum.WIDGET_ARROW_RIGHT : iconsEnum.WIDGET_ARROW_LEFT"
    [size]="iconSize.XS"
    class="text-solid-white-500"
  />
</button>
